import { useCallback } from 'react';
import { siteConfig } from '../mock';

/**
 * Opens the external SalonLife booking page in a new browser tab.
 * Used by every "Broneeri aeg" / "Broneerimine" trigger across the site.
 */
export const useBooking = () => {
  const openBooking = useCallback(() => {
    window.open(siteConfig.bookingUrl, '_blank', 'noopener,noreferrer');
  }, []);

  return openBooking;
};
